import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class CursoAprendizajeApi {
    
    static activar(id, token) {  
       return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/cursoaprendizaje/activar/"+id,
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token) {  
       return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/cursoaprendizaje/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getCursoAprendizajeList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
         return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/cursoaprendizaje?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getCursoAprendizaje(id, token ) {  
         return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/cursoaprendizaje/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(cursoaprendizaje, token ) {          
      let cursoaprendizajeEnvio = Object.assign({}, cursoaprendizaje);
		let comando="POST";
		if (cursoaprendizajeEnvio.id > 0) {
			comando="PUT";			
		} 
		cursoaprendizajeEnvio=JSON.stringify(cursoaprendizajeEnvio);
		return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/cursoaprendizaje/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: cursoaprendizajeEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    static getCursoAprendizajeCombo(token ) {

		return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/cursoaprendizaje/combo/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     

    
}